document.querySelectorAll('[data-select]').forEach(select => {
    function updateSelectStyle() {
        if (select.value === "") {
            select.classList.add('_placeholder');
        } else {
            select.classList.remove('_placeholder');
        }
        select.classList.remove('_open');
    }

    updateSelectStyle();

    select.addEventListener('change', updateSelectStyle);

    // select.addEventListener('click', () => {
    //     select.classList.toggle('_open');
    //
    // });    select.addEventListener('focus', () => {
    //     select.classList.add('_open');
    // });
    //
    // select.addEventListener('blur', () => {
    //     select.classList.remove('_open');
    // });
});

document.querySelectorAll('[data-password-show]').forEach(select => {

    const hasSmallSibling = Array.from(select.parentNode.children).some((sibling) => {
        return sibling !== select && sibling.tagName.toLowerCase() === 'small';
    });

    if (hasSmallSibling) select.parentNode.classList.add('form__item_password-eye-with-text');

    select.addEventListener('click', () => {
        const inputTarget = select.nextElementSibling;
        const type = inputTarget.getAttribute('type') === 'password' ? 'text' : 'password';
        inputTarget.setAttribute('type', type);
    });
});

//todo: make class, check elements exist